import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Avatar,
  Grid,
  Container,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BOOKINGS } from '../../component/common/Routes/AppRoutes';
import { VENDOR_BOOKINGS } from '../../component/common/Routes/VendorRoutes';
import { CUSTOMER_BOOKINGS } from '../../component/common/Routes/CustomerRoutes';
import '../../styles/SuccessPage.css';
import { resetBookingDetails } from '../../redux/Bookings/BookingAction';

const ComplementarySuccessPage = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const getBookingsRoute = () => {
    switch (user.role) {
      case 'Admin':
        return BOOKINGS;
      case 'Staff':
        return BOOKINGS;
      case 'Vendor':
        return VENDOR_BOOKINGS;
      case 'Customer':
        return CUSTOMER_BOOKINGS;
      default:
        return BOOKINGS;
    }
  };
  const location = useLocation();
   const pnrNumber = location.state?.pnr_number;
  
  
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetBookingDetails());
  }, []);

  return (
    <Box className='success-page'>
      <Container maxWidth='md'>
        <Paper elevation={4} className='success-container fade-in'>
          <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
            <Avatar className='success-icon' sx={{ backgroundColor: '#4CAF50' }}>
              <CheckCircleIcon sx={{ fontSize: 50 }} />
            </Avatar>
          </Box>

          <Typography variant='h5' className='success-title slide-down' sx={{ color: '#4CAF50', mb: 2 }}>
            Complementary Booking Confirmed!
          </Typography>

          <Typography
            variant='h6'
            className='success-message slide-down slide-delay-1'
            sx={{ mb: 3 }}
          >
            Your free booking has been successfully confirmed. Thank you for choosing our service!
          </Typography>

          <Box className='pnr-section slide-down slide-delay-2' sx={{ mb: 3 }}>
            <Typography variant='h6' className='pnr-title'>
              Payment Reference Number :
              <span
                style={{
                  color: '#4CAF50',
                  fontWeight: 'bold',
                  marginLeft: '8px'
                }}
              >
                {" "}{pnrNumber}
              </span>
            </Typography>
          </Box>

          <Box className='booking-details slide-down slide-delay-2' sx={{ mb: 4 }}>
            <Typography variant='h6' className='booking-title' sx={{ mb: 2, color: '#FF9800' }}>
               Complementary Service Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper 
                  sx={{ 
                    p: 2, 
                    backgroundColor: '#f8f9fa', 
                    border: '2px solid #4CAF50',
                    borderRadius: 2 
                  }}
                >
                  <Typography variant='body1' sx={{ textAlign: 'center', mb: 1, fontWeight: 'bold' }}>
                    This is a Complementary booking - No payment required!
                  </Typography>
                  {/* <Typography color='text.secondary' sx={{ textAlign: 'center' }}>
                    A confirmation email has been sent to the customer's registered email address. 
                    The booking is now active and ready for use.
                  </Typography> */}
                  {/* {customerName && (
                    <Typography sx={{ textAlign: 'center', mt: 1, fontStyle: 'italic' }}>
                      Customer: {customerName}
                    </Typography>
                  )} */}
                </Paper>
              </Grid>
            </Grid>
          </Box>

          {/* Action Buttons */}
          <Box className='success-button-container slide-down'>
            <Button
              variant='contained'
              className='view-booking-btn'
              onClick={() => navigate(getBookingsRoute())}
              sx={{ backgroundColor: '#4CAF50', '&:hover': { backgroundColor: '#45a049' } }}
            >
              View Booking
            </Button>
            <Button
              variant='outlined'
              className='return-home-btn'
              onClick={() => navigate('/dashboard')}
              sx={{ 
                borderColor: '#4CAF50', 
                color: '#4CAF50',
                '&:hover': { borderColor: '#45a049', backgroundColor: 'rgba(76, 175, 80, 0.04)' }
              }}
            >
              Return Home
            </Button>
          </Box>

          {/* Decorative Elements */}
          <Box className='decorative-container'>
            <Box className='decorative-circle-green success-icon' />
            <Box className='decorative-circle-blue success-icon' />
            <Box 
              sx={{
                position: 'absolute',
                top: '20%',
                right: '15%',
                width: 20,
                height: 20,
                backgroundColor: '#FF9800',
                borderRadius: '50%',
                opacity: 0.7,
                animation: 'float 3s ease-in-out infinite'
              }}
            />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ComplementarySuccessPage;